var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-description"},[_c('p',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.types && _vm.types.length)?_vm._l((_vm.types),function(item){return _c('p',{key:item,staticClass:"card-title_small"},[_vm._v(" "+_vm._s(item)+" ")])}):_c('p',{staticClass:"card-title_small"},[_vm._v(_vm._s(_vm.type))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }